



















import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { AppModule } from "@/store/modules/app"
import { TreasureBookModule } from "@/store/modules/treasureBook";

@Component({
  name: "front-edit",
  components: {
  }
})
export default class TitleImage extends Vue {
  get name() {
    return TreasureBookModule.name === 'Name des Kindes' ? '' : TreasureBookModule.name
  }

  get parentGender() {
    return TreasureBookModule.parentGender
  }

  get coverType() {
    return TreasureBookModule.coverType
  }
}
